import React from 'react';
import styled, { keyframes } from 'styled-components';

const ellipsis1 = keyframes`
  0% { transform: scale(0); }
  100% { transform: scale(1); }
`;

const ellipsis2 = keyframes`
  0% { transform: translate(0, 0); }
  100% { transform: translate(24px, 0); }
`;

const ellipsis3 = keyframes`
  0% { transform: scale(1); }
  100% { transform: scale(0); }
`;

const StyledLoader = styled.span`
  transform: translate(-50%, -50%);
  position: absolute;
  top: 50%;
  left: 50%;
  display: inline-block;
  height: 32px;
  width: 32px;

  & > span {
    display: block;
    position: absolute;
    top: 42%;
    width: 17%;
    height: 17%;
    border-radius: 50%;
    background: var(--black);
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }

  & > span:nth-child(1),
  span:nth-child(2) {
    left: 9.37%;
    animation: ${ellipsis1} 0.6s infinite;
  }

  & > span:nth-child(3) {
    left: 40.06%;
    animation: ${ellipsis2} 0.6s infinite;
  }

  & > span:nth-child(4) {
    left: 70.03%;
    animation: ${ellipsis3} 0.6s infinite;
  }
`;

const Loader: React.FC = () => {
  return (
    <StyledLoader data-testid="spinner">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </StyledLoader>
  );
};

export default Loader;
